var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Logo, Text, Flex, Link } from "./..";
import { containerLss, linkLss, footerTextLss } from './styles';
var Copy = function (_a) {
    var year = _a.year;
    return (React.createElement(React.Fragment, null,
        "Copyright \u00A9 ",
        year,
        " Lucid Holdings, LLC. All rights reserved."));
};
export var Footer = function (_a) {
    var 
    // eslint-disable-next-line
    productName = _a.productName, lss = _a.lss, props = __rest(_a, ["productName", "lss"]);
    var currentYear = new Date().getFullYear().toString();
    return (React.createElement(Flex, __assign({ as: "footer" }, props, { lss: __assign(__assign({}, containerLss), lss) }),
        React.createElement(Logo, { size: 16 }),
        React.createElement(Text, { lss: footerTextLss },
            React.createElement(Copy, { year: currentYear })),
        React.createElement(Flex, { lss: { ml: 'lg' } },
            React.createElement(Text, { lss: footerTextLss },
                React.createElement(Link, { lss: linkLss, to: "https://luc.id/privacy-policy/" }, "Privacy Policy")),
            React.createElement(Text, { lss: { mx: 'sm', textScale: 'caption' } }, "|"),
            React.createElement(Text, { lss: footerTextLss },
                React.createElement(Link, { lss: linkLss, to: "https://status.luc.id/" }, "Lucid Status Page")))));
};
//# sourceMappingURL=Footer.js.map